import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import jsLogo from './img/js.png';
import pythonLogo from './img/python-logo.png';
import csharpLogo from './img/c-sharp.png';
import clanguage from './img/c-logo.png';
import cpluspluslogo from './img/Cplusplus-logo.png';
import eslogo from './img/es-logo.png';
import kibanalogo from './img/kibana-logo.png';
import logstahlogo from './img/logstash-logo.png';
import postgreslogo from './img/postgres.png';
import mysqllogo from './img/mysql-logo.png';
import solrlogo from './img/apache-solr.png';
import nodejslogo from './img/nodejs.png';
import expresslogo from './img/express-logo.png';
import githublogo from './img/github-logo.png';
import unitylogo from './img/unity-logo.png';
import Divider from 'material-ui/Divider';

import reactlogo from './img/react.png';
import reduxlogo from './img/react.png';
import csslogo from './img/css-logo.png';
import htmllogo from './img/html5-logo.png';
import bootstraplogo from './img/bootstrap-logo.png';
import d3logo from './img/d3.png';
import jquerylogo from './img/jquery.png';
import materiallogo from './img/material.png';
import './Technology.css';

class Technology extends Component {
    render() {
        let leftPosition = this.props.browser.greaterThan.medium || this.props.responsiveDrawer.open ? 200 : 0;

        const style = {
            height: '30px',
            textAlign: 'center',
            backgroundColor: '#b2ff59',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0,
            marginLeft: leftPosition,
        };

        const paperStyle = {
            height: 150,
            width: 120,
            margin: 20,
            textAlign: 'center',
            display: 'inline-block',
            verticalAlign: 'top'
        } 

        return (
            <Grid className="Technology" style={{ margin: 0, width: '100%', backgroundColor: '#efebe9' }}>
                <Row style={{ margin: 0 }}>
                    <Col xs style={{ padding: 0 }}>
                        <Paper style={style} zDepth={1}    
                        />
                    </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                    <Col xs style={{ marginLeft: leftPosition, padding: 50 }}>
                        <h1 style={{ marginLeft: 18}}>Languages</h1>
                        <Paper
                            style={paperStyle}
                            zDepth={1} 
                            children={
                                <div>
                                    <img 
                                        src={jsLogo}
                                        style={{height: '80%', width: '100%', top: 0}} 
                                    />
                                    <h4 style={{margin: 0}}>Javascript</h4>
                                </div>
                            }
                        />
                        <Paper 
                            style={paperStyle}
                            zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={pythonLogo} 
                                        style={{height: '80%', width: '100%', top: 0}}
                                    />
                                    <h4 style={{margin: 0}}>Python</h4>
                                </div>
                            }
                        />
                        <Paper 
                            style={paperStyle}
                            zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={csharpLogo} 
                                        style={{position: 'relative', width: '80%', top: 20}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 22}}>C#</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={clanguage} 
                                        style={{position: 'relative', width: '100%', top: 10}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 2}}>C</h4> 
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={cpluspluslogo} 
                                        style={{position: 'relative', width: '100%', top: 10}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 2}}>C++</h4> 
                                </div>
                            }
                        />
                        
                    </Col> 
                </Row>
                <Divider style={{ backgroundColor: '#b2ff59' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs style={{ marginLeft: leftPosition, padding: 50 }}>
                        <h1 style={{ marginLeft: 18}}>Tools/Frameworks</h1>                        
                        <Paper 
                            style={paperStyle}
                            zDepth={2}
                                children={
                                    <div>
                                        <img 
                                            src={eslogo} 
                                            style={{position: 'relative', width: '80%', top: 20}}
                                        />
                                        <h4 style={{position: 'relative', margin: 0, top: 22}}>Elasticsearch</h4>
                                    </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={kibanalogo} 
                                        style={{position: 'relative', width: '70%', top: 30}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 35}}>Kibana</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={logstahlogo} 
                                        style={{position: 'relative', width: '70%', top: 25}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 25}}>Logstash</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={postgreslogo} 
                                        style={{position: 'relative', width: '70%', top: 25}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 30}}>Postgres</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={mysqllogo} 
                                        style={{position: 'relative', width: '80%', top: 25}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 50}}>MySQL</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={solrlogo} 
                                        style={{position: 'relative', width: '80%', top: 20}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 20}}>Apache Solr</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={nodejslogo} 
                                        style={{position: 'relative', width: '80%', top: 50}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 55}}>Node.js</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={expresslogo} 
                                        style={{position: 'relative', width: '100%', top: 50}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 82}}>Express.js</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={githublogo} 
                                        style={{position: 'relative', width: '90%', top: 50}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 90}}>Github</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={unitylogo} 
                                        style={{position: 'relative', width: '70%', top: 20}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 32}}>Unity</h4>
                                </div>
                            }
                        />
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#b2ff59' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs style={{ marginLeft: leftPosition, padding: 50 }}>
                        <h1 style={{ marginLeft: 18}}>Front End</h1>
                        <Paper 
                            style={paperStyle}
                            zDepth={2}
                                children={
                                    <div>
                                        <img 
                                            src={reactlogo} 
                                            style={{position: 'relative', width: '80%', top: 20}}
                                        />
                                        <h4 style={{position: 'relative', margin: 0, top: 25}}>React</h4>
                                    </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={csslogo} 
                                        style={{position: 'relative', width: '90%', top: 20}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 14}}>CSS3</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={htmllogo} 
                                        style={{position: 'relative', width: '72%', top: 29}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 35}}>HTML5</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={bootstraplogo} 
                                        style={{position: 'relative', width: '80%', top: 20}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 26}}>Bootstrap3</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={d3logo} 
                                        style={{position: 'relative', width: '90%', top: 20}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 15}}>D3.js</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={jquerylogo} 
                                        style={{position: 'relative', width: '90%', top: 20}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 15}}>jQuery</h4>
                                </div>
                            }
                        />
                        <Paper 
                        style={paperStyle}
                        zDepth={2}
                            children={
                                <div>
                                    <img 
                                        src={materiallogo} 
                                        style={{position: 'relative', width: '80%', top: 30}}
                                    />
                                    <h4 style={{position: 'relative', margin: 0, top: 45}}>Material-UI</h4>
                                </div>
                            }
                        />

                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    const { browser, responsiveDrawer } = state;
    return {
        browser,
        responsiveDrawer
    };
};

export default connect(mapStateToProps, null)(Technology);


// WEBPACK FOOTER //
// ./src/Technology.js